import { Box } from "@mui/system";
import styled from "styled-components";
import { createTheme } from "@mui/material/styles";

export const TimePickerFieldStyled = styled(Box)`
  .label {
    color: var(--slate-blue-color);
    font-weight: 500;
    font-size: 14px;
  }
  .MuiIconButton-root {
    margin-right: 0px;
  }
`;

export const theme = createTheme({
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            padding: "8px",
          },
          "& .MuiInputBase-input": {
            fontSize: "14px",
            fontWeight: 500,
          },
        },
      },
    },
  },
});
